import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DatePipe, Location } from '@angular/common';
import { BookingService } from '@shared/services/booking.service';
import { ApiService } from '@shared/services/api.service';
import { BookingUtilsService } from '@shared/services/booking-utils.service';
import { IBooking } from '@shared/interfaces/bookings.interface';
import { format } from 'date-fns';

@Component({
  selector: 'app-pay-booking',
  templateUrl: './pay-booking.component.html',
  styleUrls: ['./pay-booking.component.scss']
})
export class PayBookingComponent implements OnInit {

  @ViewChild("calculator") calculatorField!: ElementRef;

  public employee: any | undefined;
  public selectedEmployee: any | undefined;
  public display = '';
  public firstValue: number | null = null;
  public action: string | null = null;
  public isResultDisplayed = false;
  public putMoney!: number;
  private lastButton: HTMLElement | null = null;
  public inOperation: boolean = false;

  public bookingDetail!: IBooking;
  public amount: any = '';
  public change: number = 0;
  public ticketData: any[] = [];
  public confirmedEntry: boolean = false;
  public selectedPaymentType!: string;
  public dateTodayToPayment: Date = new Date();
  public services: any[] = [];

  constructor(
    public route: ActivatedRoute,
    public location: Location,
    private apiService: ApiService,
    private datePipe: DatePipe,
  ) {}

  ngOnInit() {
    const idBooking = this.route.snapshot.paramMap.get('id');
    this.route.queryParams.subscribe(params => {
      this.amount = '';
    });

    this.apiService.getServicesList().subscribe((response: any) => {
      this.services = response;
    });

    if (idBooking) {
      this.apiService.getBookingById(idBooking).subscribe(
        (response: any) => {
          this.bookingDetail = response as IBooking;
          this.bookingDetail.pending_amount = BookingUtilsService.calculatePendingAmount(this.bookingDetail);
          if (this.amount !== undefined  && !isNaN(this.amount) && this.amount !== 0) {
            this.changeToReturn();
          }
        })
    }

    this.apiService.getUsers().subscribe(
      (response: any) => {
        this.employee = response;
      });
  }

  formatFullDateTime(isoDataString: string) {
    if(!isoDataString) {
      return 'Fecha y hora no disponiles'
    }
    const date = new Date(isoDataString);
    return format(date, 'dd-MM-yyyy HH:MM');
  }

  formatDate(date: Date): string {
    return this.datePipe.transform(date, 'dd/MM/yyyy') || '';
  }

  goBack() {
    this.location.back();
  }

  getService(serviceId: number) {
    const service = this.services.find((profile: any) => profile.id === serviceId);
    return service ? service.name : 'Servicio Desconocido';
  }

  changeToReturn() {
    if (this.amount !== undefined && this.bookingDetail !== undefined) {
      const pendingAmount = this.bookingDetail.pending_amount;

      if (!isNaN(this.amount) && !isNaN(pendingAmount) && !isNaN(this.putMoney)) {
        this.change =  this.putMoney - parseFloat(this.display);
      } else {
        this.change = 0;
      }
    } else {
      this.change = 0;
    }

  }

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {

    if (this.lastButton) {
      this.lastButton.style.backgroundColor = '';
    }

    const target = event.target as HTMLElement;

    if (target.tagName === 'BUTTON') {
      target.style.backgroundColor = 'blue';
      this.lastButton = target;

      setTimeout(() => {
        target.style.backgroundColor = '';
      }, 300);
    }
  }

  reset() {
    this.display = '';
    this.firstValue = null;
    this.action = null;
    this.isResultDisplayed = false;
  }

  numClick(val: string) {
    if (this.isResultDisplayed) {
      this.display = '';
      this.isResultDisplayed = false;
    }

    const maxLength = 9;
    if (this.display.length >= maxLength) {
      return;
    }

    if (val === '.' && this.display.includes('.') || val === '.' && this.display === '') {
      return;
    }

    if (this.display === '0') {
      if (val === '.') {
        this.display += val;
      } else {
        this.display = val;
      }
    } else {
      this.display += val;
    }
    this.changeToReturn();
  }

  backspace() {
    if (this.display.length > 0) {
      if (this.display.endsWith(' ')) {
        this.display = this.display.substring(0, this.display.length - 2);
      } else {
        this.display = this.display.substring(0, this.display.length - 1);
      }
    }
  }

  oper(action: string | null) {
    if (this.display === '' && action === '-') {
      this.display = '-';
      return;
    }

    if (this.display === '-') {
      return;
    }

    if (['+', '-', '*', '/', '%'].includes(this.display.trim().slice(-1))) {
      this.display = this.display.trim().slice(0, -1);
    } else {

      if (this.firstValue !== null && this.action && this.display !== '' && action !== '%') {
        this.calculate();
        this.display = this.display;
        this.firstValue = parseFloat(this.display);
      } else if (this.firstValue !== null && this.action == '*' && this.display !== '' && action == '%') {
        this.action = action;
        this.calculate();
        this.action = '';
        action = '';
      } else if (this.firstValue !== null && this.action == '-' && this.display !== '' && action == '%') {
        this.action = '%-';
        this.calculate();
        this.action = '';
        action = '';
      } else if (this.firstValue !== null && this.action == '+' && this.display !== '' && action == '%') {
        this.action = '%+';
        this.calculate();
        this.action = '';
        action = '';
      } else if (this.display !== '') {
        this.firstValue = parseFloat(this.display);
      }
    }

    this.display += ' ' + action;
    this.action = action;
    this.isResultDisplayed = true;
  }

  calculate() {
    if (this.firstValue === null || this.action === null) {
      return;
    }
    const secondValue = parseFloat(this.display);
    let result: number | undefined;

    switch (this.action) {
      case '+':
        result = this.firstValue + secondValue;
        break;
      case '-':
        result = this.firstValue - secondValue;
        break;
      case '*':
        result = this.firstValue * secondValue;
        break;
      case '/':
        result = this.firstValue / secondValue;
        break;
      case '%':
        result = (this.firstValue * secondValue) / 100;
        break;
      case '%-':
        result = this.firstValue - (this.firstValue * secondValue) / 100;
        break;
      case '%+':
        result = this.firstValue + (this.firstValue * secondValue) / 100;
        break;
    }

    if (result !== undefined) {
      this.display = result.toFixed(2);
      this.isResultDisplayed = true;
      this.firstValue = null;
      this.action = null; //
      this.inOperation = false;
      if(this.amount !== ''){
        this.changeToReturn();
      }
    }
  }

  changeSign() {
    if (this.display.startsWith('-')) {
      this.display = this.display.substring(1);
    } else if (this.display !== '' && this.display !== '0') {
      this.display = '-' + this.display;
    }
  }

  @HostListener('window:keydown', ['$event'])
  keyboardCalculator(event: KeyboardEvent) {
    event.stopImmediatePropagation();
    const key = event.key;
    const isInputFocused = document.activeElement instanceof HTMLInputElement;

    if (!isInputFocused) {
      const calculatorFocused = document.activeElement === this.calculatorField.nativeElement;


      if (calculatorFocused) {
        switch (key) {
          case '0': case '1': case '2': case '3': case '4':
          case '5': case '6': case '7': case '8': case '9':
            this.numClick(key);
            break;
          case '.':
            this.numClick('.');
            break;
          case '+': case '-': case '*': case '/': case '%':
            this.oper(key);
            break;
          case 'Backspace':
            this.reset();
            break;
          case 'Enter':
            this.calculate();
            break;
        }
      }
    }
  }

  handlePutMoneyKeydown(event: KeyboardEvent) {
    event.stopPropagation();
  }

  paymentType(paymentType: string) {
    switch (paymentType) {
      case 'EFECTIVO':
        break;
      case 'TARJETA':
        break;
      case 'BIZUM':
        break;
      case 'TRANSFERENCIA':
        break;
    }
    this.selectedPaymentType = paymentType;
  }

  confirmBooking() {
      const cashierEntry = {
        amount: this.display,
        payment_method: this.selectedPaymentType,
        concept: this.bookingDetail.reference,
        concept_related : 'App\Http\Models\Booking::class',
        booking_id: this.bookingDetail.id,
        received: this.putMoney
      }

      this.apiService.post('/cashier-entry/save', cashierEntry).subscribe(
        (response: any) => {
          this.display = '0';
          this.confirmedEntry = true;
          this.display = '';
          this.putMoney = 0;
          this.selectedPaymentType = '';
          this.ticketData.push({id:response.id, ...cashierEntry});
        },
        (error) => {
          console.log('Error crear entrada de caja', error);
        }
      )
    }

    printTicket() {
      this.apiService.post('/ticket/generate', this.ticketData).subscribe(
        (response: any) => {
          // this.ticketData = [];
        },
        (error) => {
          console.log('Error crear ticket', error);
        }
      )
    }

}
